import React from "react";

const WhyInvestEtf1 = ({ ...rest }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="49"
            height="49"
            viewBox="0 0 49 49"
            fill="none"
            {...rest}
        >
            <rect opacity="0.2" x="4.25" y="5" width="44" height="44" fill="#283A97" />
            <rect x="1" y="1" width="44" height="44" stroke="#283A97" strokeWidth="2" />
            <path
                d="M19.7918 25.4444C19.7918 26.6256 20.7494 27.5833 21.9307 27.5833H23.9168C25.1825 27.5833 26.2085 26.5572 26.2085 25.2916C26.2085 24.0259 25.1825 22.9999 23.9168 22.9999H22.0835C20.8178 22.9999 19.7918 21.9739 19.7918 20.7083C19.7918 19.4426 20.8178 18.4166 22.0835 18.4166H24.0696C25.2509 18.4166 26.2085 19.3742 26.2085 20.5555M23.0002 17.0416V18.4166M23.0002 27.5833V28.9583M32.1668 22.9999C32.1668 28.0625 28.0628 32.1666 23.0002 32.1666C17.9376 32.1666 13.8335 28.0625 13.8335 22.9999C13.8335 17.9373 17.9376 13.8333 23.0002 13.8333C28.0628 13.8333 32.1668 17.9373 32.1668 22.9999Z"
                stroke="#283A97"
                strokeWidth="1.83563"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default WhyInvestEtf1;
